import { FC } from 'react';
import { Button, DialogActions, Stack } from '@mui/material';
import { FormattedMessage } from 'react-intl';

type Props = Readonly<{
	isLoading: boolean;
	isFirst: boolean;
	isLast: boolean;
	showSkip: boolean;
	onCancel: () => void;
	onBack: () => void;
}>;

const getSubmitButtonLabel = ({ isLoading, showSkip, isLast }: Pick<Props, 'isLoading' | 'showSkip' | 'isLast'>) => {
	if (isLoading) {
		return <FormattedMessage id={'common.loading'} />;
	}

	if (showSkip) {
		return <FormattedMessage id={'common.skip'} />;
	}

	if (isLast) {
		return <FormattedMessage id={'common.create'} />;
	}

	return <FormattedMessage id={'common.next'} />;
};

const CreateMetricActions: FC<Props> = ({ isLoading, isFirst, isLast, showSkip, onCancel, onBack }) => {
	return (
		<DialogActions sx={{ p: 2.5 }}>
			<Stack direction={'row'} spacing={2} alignItems={'center'} width={'100%'} justifyContent={'end'}>
				<Button color={'secondary'} onClick={isFirst ? onCancel : onBack}>
					{isFirst ? <FormattedMessage id={'common.cancel'} /> : <FormattedMessage id={'common.back'} />}
				</Button>
				<Button type={'submit'} variant={'contained'} disabled={isLoading}>
					{getSubmitButtonLabel({ isLoading, showSkip, isLast })}
				</Button>
			</Stack>
		</DialogActions>
	);
};

export { CreateMetricActions };
